import React, { Component } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { Card, Row, Col, CardBody } from "reactstrap";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { Link } from "react-router-dom";
import { Anchor } from "grommet";
import QandA from "./QandA";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import MaterialComponent from "./LearnerAssesment/MaterialComponent";
//import Spinner from "../sample/spinner";
import Tooltip from "@material-ui/core/Tooltip";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import "../../css/course-catelog.css";
import Chip from "@material-ui/core/Chip";
import ScheduleIcon from "@material-ui/icons/Schedule";
import CancelIcon from "@material-ui/icons/Cancel";
class ShowQnA extends Component {
  constructor(props) {
    super(props);
    // console.log("gg =" + props.title);
    const forumThreadslist = [];
    const savedforumThreadslist = [];
    const learnerUid = "";
    const ftopicid = "";
    const isFtClosed = "";

    this.state = {
      forumThreadslist,
      savedforumThreadslist,
      learnerUid,
      ftopicid,
      isFtClosed,
      isLoading: false,
      issavedata: false,
      modalIsOpen: false,
      secondModalIsOpen: false,
      isreviewed: true,
      selectedAnsFile: null,
      answertext: "",
      qName: props.title,
      qPostedBy: props.postedBy,

      qCreationDate: props.creationDate,
      qForumThreadsSize: props.forumThreadsSize,
      qDescription: props.description,
      qFilename: props.filename,
      qForumtopicid: props.forumtopicid,
      loading: false,
    };

    this.openSecondModal = this.openSecondModal.bind(this);
    this.closeSecondModal = this.closeSecondModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.routeChange = this.routeChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.getshowqna();
  }

  async getshowqna() {
    let formData = new FormData();
    formData.append("cofflearn", localStorage.getItem("state"));

    formData.append("ftid", this.state.qForumtopicid);
    axios
      .post("ForumTopic/showqna", formData)
      .then((res) => {
        if (res.data.status === "200") {
          this.setState({
            forumThreadslist: res.data.forumThreadslist,
            learnerUid: res.data.learnerUid,
            isFtClosed: res.data.isFtClosed,
            ftopicid: res.data.ftopicid,
          });

          return res;
        }
        throw res;
      })
      .catch((error) => {
        toast.error("Please try again!!", {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  }

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  closeModal() {
    this.setState({ modalIsOpen: false });
  }

  openSecondModal() {
    this.setState({
      secondModalIsOpen: true,
    });
  }

  closeSecondModal() {
    this.setState({ secondModalIsOpen: false });
  }

  routeChange() {
    this.setState({ isreviewed: "" });
  }

  handleChange(e) {
    let name = e.target.name;
    let val = e.target.value;
    this.setState({ [name]: val });
  }
  sleep(milliseconds) {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  }
  handleSubmit(e, topicid) {
    e.preventDefault();
    this.savepostThread(topicid);
  }

  async savepostThread(topicid) {
    this.setState({ loading: true });
    if (this.state.selectedAnsFile) {
      let filename = this.state.selectedAnsFile.name.split(".").pop();
      if (
        filename !== "pdf" &&
        filename !== "jpg" &&
        filename !== "xls" &&
        filename !== "jpeg" &&
        filename !== "xlsx" &&
        filename !== "docx" &&
        filename !== "doc" &&
        filename !== "png" &&
        filename !== "zip" &&
        filename !== "rar" &&
        filename !== "txt"
      ) {
        // console.log("upload only" + filename);
        toast.error(" upload only pdf/jpg/jpeg/docx/txt/xlsx/png/rar/zip files");
        await this.sleep(3000);
        this.setState({ loading: false });
        return;
      }
    }

    var formData = new FormData();
    formData.append("cofflearn", localStorage.getItem("state"));
    formData.append("ftid", this.state.qForumtopicid);
    formData.append("comment", this.state.answertext);

    if (this.state.selectedAnsFile != null) {
      formData.append("coursePic", this.state.selectedAnsFile);
    } else {
      formData.append("coursePic", null);
    }

    formData.append("topicid", topicid);
    formData.append("from", "qna");
    formData.append("typeid", localStorage.getItem("usertype"));

    axios
      .post("ForumTopic/postThread", formData)

      .then((res) => {
        if (res.data.status === "200") {
          this.setState({
            loading: false,
            savedforumThreadslist: res.data.savedforumThreadslist,
            issavedata: true,
            selectedAnsFile: null,
            answertext: "",
          });
          toast.success(res.data.msg);
        } else {
          toast.error("Something went wrong");
        }
      }).catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  }

  render() {
    if (!this.state.isreviewed) {
      return <QandA />;
    }
    return (
      <div className="bg-color1">
        <br />
        <Card className="m-4">
          <CardBody>
            <Row>
              <Col sm={12}>
                <div class="row">
                  <div class="col-md-5">
                  {/* <Chip
                      size="medium"
                      label={this.state.qName}
                    /> */}
                     <Chip
                      size="medium"
                      label={this.state.qName}
                    />
                  </div>
                  <div class="col-md-1 text-center">
                    <Chip
                      size="small"
                      label={this.state.qForumThreadsSize}
                      className="resp-chip"
                    />
                    <br /> Response{" "}
                  </div>
                  <div class="col-md-5 text-right pt-2">
                    <p>
                      {" "}
                      Posted By {this.state.qPostedBy}
                      <ScheduleIcon className="schedule-icon1" />{" "}
                      {this.state.qCreationDate}
                    </p>
                  </div>
                  <div class="col-md-1 text-right">
                  <Tooltip title="Close">
                    <Anchor onClick={this.routeChange}>
                      <button type="submit" class="btn_1_cancel">
                        {" "}
                        <CancelIcon />
                      </button>
                    </Anchor>
                    </Tooltip>
                  </div>
                </div>
                <br />

                <div class="row">
                  <div class="col-md-6">
                    <h5>{this.state.qPostedBy}</h5>
                    
                    <span> {this.state.qDescription}</span>
                    <br />
                    {this.state.qFilename !== null ? (
                      <>
                        <Row>
                          <Col sm={12}>
                            <Link onClick={this.openModal}>
                              Downloadable Attachment &nbsp;&nbsp;{" "}
                              <FontAwesomeIcon icon={faDownload} />{" "}
                            </Link>
                          </Col>
                          <Modal
                            isOpen={this.state.modalIsOpen}
                            onRequestClose={this.closeModal}
                            size="md"
                          >
                            <ModalHeader toggle={this.closeModal}></ModalHeader>
                            <ModalBody>
                              <div>
                                <MaterialComponent
                                  contentType="contenttype"
                                  contentId="0"
                                  materialid="0"
                                  materialtype={this.state.qFilename
                                    .split(".")
                                    .pop()}
                                  materialpath={this.state.qFilename}
                                />
                              </div>
                            </ModalBody>
                          </Modal>
                        </Row>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
                <hr />
                <div className="bg-qna">
                  {this.state.issavedata === false ? (
                    <>
                      {this.state.forumThreadslist.map((item, index1) => (
                        <>
                          <div class="row mb-3">
                            {item.postedbyemail === this.state.learnerUid ? (
                              <>
                                <div class="col-md-6"></div>
                                <div class="col-md-6 card p-3 other12">
                                  <div className="row pb-3">
                                    <div class="col-md-6 text-left">
                                      <b>{item.firstName}</b>
                                    </div>
                                    <div class="col-md-6 text-right">
                                      <b>{item.creation_date}</b>
                                    </div>
                                  </div>
                                  {item.comment}
                                  <br />
                                  {item.prevpath !== null ? (
                                    <>
                                      <Row>
                                        <Col sm={12}>
                                          <Link onClick={this.openSecondModal}>
                                            Downloadable Attachment &nbsp;&nbsp;{" "}
                                            <FontAwesomeIcon
                                              icon={faDownload}
                                            />{" "}
                                          </Link>
                                        </Col>
                                        <Modal
                                          isOpen={this.state.secondModalIsOpen}
                                          onRequestClose={this.closeSecondModal}
                                          size="lg"
                                          style={{
                                            top: "0%",
                                            left: "0%",
                                            right: "0%",
                                            bottom: "0%",
                                            maxWidth: "1600px",
                                            width: "60%",
                                            height: "60%",
                                          }}
                                        >
                                          <ModalHeader
                                            toggle={this.closeSecondModal}
                                          ></ModalHeader>
                                          <ModalBody>
                                            <div>
                                              <MaterialComponent
                                                contentType="contenttype"
                                                contentId="0"
                                                materialid="0"
                                                materialtype={item.prevpath
                                                  .split(".")
                                                  .pop()}
                                                materialpath={item.prevpath}
                                              />
                                            </div>
                                          </ModalBody>
                                        </Modal>
                                      </Row>
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                </div>
                              </>
                            ) : (
                              <>
                                <div class="col-md-6 card p-3">
                                  <div className="row pb-3">
                                    <div class="col-md-6 text-left">
                                      <b>{item.firstName}</b>
                                    </div>
                                    <div class="col-md-6 text-right">
                                      <b>{item.creation_date}</b>
                                    </div>
                                  </div>
                                  {item.comment}
                                  <br />
                                  {item.prevpath !== null ? (
                                    <>
                                      <Row>
                                        <Col sm={12}>
                                          <Link onClick={this.openSecondModal}>
                                            Downloadable Attachment &nbsp;&nbsp;{" "}
                                            <FontAwesomeIcon
                                              icon={faDownload}
                                            />{" "}
                                          </Link>
                                        </Col>
                                        <Modal
                                          isOpen={this.state.secondModalIsOpen}
                                          onRequestClose={this.closeSecondModal}
                                          size="md"
                                        >
                                          <ModalHeader
                                            toggle={this.closeSecondModal}
                                          ></ModalHeader>
                                          <ModalBody>
                                            <div>
                                              <MaterialComponent
                                                contentType="contenttype"
                                                contentId="0"
                                                materialid="0"
                                                materialtype={item.prevpath
                                                  .split(".")
                                                  .pop()}
                                                materialpath={item.prevpath}
                                              />
                                            </div>
                                          </ModalBody>
                                        </Modal>
                                      </Row>
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                </div>
                              </>
                            )}
                          </div>
                        </>
                      ))}
                    </>
                  ) : (
                    <>
                      {this.state.savedforumThreadslist.map((item, index1) => (
                        <>
                          <div class="row mb-3">
                            {item.postedbyemail === this.state.learnerUid ? (
                              <>
                                <div class="col-md-6"></div>
                                <div class="col-md-6 card p-3 ">
                                  <div className="row pb-3">
                                    <div class="col-md-6 text-left">
                                      <b>{item.firstName}</b>
                                    </div>
                                    <div class="col-md-6 text-right">
                                      <b>{item.creation_date}</b>
                                    </div>
                                  </div>
                                  {item.comment}
                                  <br />
                                  {item.prevpath !== null ? (
                                    <>
                                      <Row>
                                        <Col sm={12}>
                                          <Link onClick={this.openSecondModal}>
                                            Downloadable Attachment &nbsp;&nbsp;{" "}
                                            <FontAwesomeIcon
                                              icon={faDownload}
                                            />{" "}
                                          </Link>
                                        </Col>
                                        <Modal
                                          isOpen={this.state.secondModalIsOpen}
                                          onRequestClose={this.closeSecondModal}
                                          size="md"
                                        >
                                          <ModalHeader
                                            toggle={this.closeSecondModal}
                                          ></ModalHeader>
                                          <ModalBody>
                                            <div>
                                              <MaterialComponent
                                                contentType="contenttype"
                                                contentId="0"
                                                materialid="0"
                                                materialtype={item.prevpath
                                                  .split(".")
                                                  .pop()}
                                                materialpath={item.prevpath}
                                              />
                                            </div>
                                          </ModalBody>
                                        </Modal>
                                      </Row>
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                </div>
                              </>
                            ) : (
                              <>
                                <div class="col-md-6 card p-3">
                                  <div className="row pb-3">
                                    <div class="col-md-6 text-left">
                                      <b>{item.firstName}</b>
                                    </div>
                                    <div class="col-md-6 text-right">
                                      <b>{item.creation_date}</b>
                                    </div>
                                  </div>
                                  {item.comment}
                                  <br />
                                  {item.prevpath !== null ? (
                                    <>
                                      <Row>
                                        <Col sm={12}>
                                          <Link onClick={this.openSecondModal}>
                                            Downloadable Attachment &nbsp;&nbsp;{" "}
                                            <FontAwesomeIcon
                                              icon={faDownload}
                                            />{" "}
                                          </Link>
                                        </Col>
                                        <Modal
                                          isOpen={this.state.secondModalIsOpen}
                                          onRequestClose={this.closeSecondModal}
                                          size="md"
                                        >
                                          <ModalHeader
                                            toggle={this.closeSecondModal}
                                          ></ModalHeader>
                                          <ModalBody>
                                            <div>
                                              <MaterialComponent
                                                contentType="contenttype"
                                                contentId="0"
                                                materialid="0"
                                                materialtype={item.prevpath
                                                  .split(".")
                                                  .pop()}
                                                materialpath={item.prevpath}
                                              />
                                            </div>
                                          </ModalBody>
                                        </Modal>
                                      </Row>
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                </div>
                              </>
                            )}
                          </div>
                        </>
                      ))}
                    </>
                  )}
                </div>
                {this.state.isFtClosed === false ? (
                  <>
                    <div class="row">
                      <div class="col-sm-12">
                        <label></label>

                        <textarea
                          class="form-control"
                          name="answertext"
                          placeholder="Add a response"
                          id="answertext"
                          value={this.state.answertext}
                          onChange={this.handleChange}
                          rows={3}
                          cols={120}
                          required=""
                        ></textarea>
                      </div>
                    </div>
                    <br />
                    <div class="row ">
                      <div class="col-sm-5">
                        <input
                          class="form-control"
                          id="selectedAnsFile"
                          type="file"
                          name="selectedAnsFile"
                          // value={this.state.selectedAnsFile}
                          onChange={(e) =>
                            this.setState({
                              selectedAnsFile: e.target.files[0],
                            })
                          }
                        />
                      </div>
                    </div>
                    <br />
                    <div className="row">
                      <div className="col-lg-12 text-center">
                        <Button
                          variant="contained"
                          color="primary"
                          disabled={this.state.loading}
                          onClick={(e) =>
                            this.handleSubmit(e, this.state.ftopicid)
                          }
                        >
                          Submit
                        </Button>

                        {this.state.loading === true ? (
                          <CircularProgress
                            size={24}
                            color="green"
                            className="buttonProgress1"
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                    <br />
                  </>
                ) : (
                  <></>
                )}
              </Col>
            </Row>
          </CardBody>
        </Card>
        <br />
      </div>
    );
  }
}

export default ShowQnA;
